import { request } from 'src/commons/utils/async-request';

const getSelectedApplicationEndpoint = `/ccx/ajax/selectedApplication`;

interface GetSelectedApplicationResponse {
  selectedApplicationId: string;
}

export default async (): Promise<string> => {
  try {
    const response = await request<GetSelectedApplicationResponse>({
      url: getSelectedApplicationEndpoint,
      retries: 2,
    });
    return response.selectedApplicationId;
  } catch (e) {
    return '';
  }
};
